import { useEffect } from 'react';
import { Box, AppBar, Toolbar, Button, IconButton, Typography } from '@mui/material';

import { logout } from '../login/LoginSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

const HeaderMenu = ({ pageTitle, /*backAction, logoutAction,*/ ...props }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    //const [title, setTitle] = useState(pageTitle);

    const handleLogout = () => {
        //logoutAction();
        dispatch(logout);
    };

    const handleBackAction = () => {
        //backAction();
        navigate('/summary');
    };

    useEffect(() => {
    }, []);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        onClick={handleBackAction}
                    >&lt;</IconButton>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {pageTitle}
                    </Typography>
                    <Button color="inherit" onClick={handleLogout}>Logout</Button>
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default HeaderMenu;